import React, { Fragment, useState, useEffect, useContext, useMemo, useRef } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, H3 } from "../AbstractElements";
import { Link, useNavigate, useSearchParams, useParams } from "react-router-dom"; 
import { drtsAPIURL } from '../Constant';
import { trackPromise } from 'react-promise-tracker';
import CustomizerContext from "../_helper/Customizer";
import { ToastContainer, toast } from "react-toastify";
import useFetch from "./useFetch";
import OtpApp from '../Otp/App'; 
import Select from 'react-select';
import countryList from 'react-select-country-list';
import ReCAPTCHA from 'react-google-recaptcha';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input';
//import PhoneInput from "react-phone-number-validation";



//const Signin = () => {
  export default function  Register(){

  const history = useNavigate();
  const [username, setUsername] = useState('');  
  const [omangExists, setOmangExists] = useState(false);
  const [password, setPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [togglePasswordConfirm, setTogglePasswordConfirm] = useState(false);
  const [oneGovTokenExists, setOneGovTokenExists] = useState(false);
  const [omang, setOmang] = useState(''); 
  const [firstname, setFirstname] = useState(''); 
  const [surname, setSurname] = useState(''); 
  const [phoneNumber, setPhoneNumber] = useState(''); 
  const [nationality, setNationality] = useState({ value: 'BW', label: 'Botswana' });
  const recaptcha = useRef();
  const [recaptchaValue, setRecaptchaValue] = useState('');
  const login = useState(JSON.parse(localStorage.getItem("login")))[0]; 

  const initialValues = { omang: "",firstname: "",surname: "",nationality: "",phoneNumber: "",password: "",passwordConfirm: ""}

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [registerBtnDisabled, setRegisterBtnDisabled] = useState(false);

  const params = useParams(); //alert("Token 1 is: "+ params.token);

  
  const handlePhoneChange = (value) => {

    //alert('greater: '+value);
   // if (value.length > 0 && isNaN(parseInt(value[0])) && parseInt(value[0]) !=7) {
       // value = value.substring(1);
    //}

    //if (value.length == 1 && isNaN(parseInt(value[0])) && parseInt(value[0]) !=7) {
      //value = 7;//value.substring(1);
  //} else 
  //alert('greater: '+value);
    
    setPhoneNumber(value);

    //if(isValidPhoneNumber(value)===true){

    setFormValues({ ...formValues, ["phoneNumber"]: value });

    if (formErrors["phoneNumber"]!=undefined&&formErrors["phoneNumber"]!=null) delete formErrors["phoneNumber"];
    setFormErrors(formErrors);

   // }

  }



  const handleChange = (event) => {

    const { name, value } = event.target;

    if(event.target.name=="omang") setOmang(event.target.value);
    if(event.target.name=="firstname") setFirstname(event.target.value);
    if(event.target.name=="surname") setSurname(event.target.value);
    //if(event.target.name=="nationality") setNationality(event.target.value);
    //if(event.target.name=="phoneNumber") setPhoneNumber(event.target.value);           
    if(event.target.name=="password") setPassword(event.target.value);           
    if(event.target.name=="passwordConfirm") setPasswordConfirm(event.target.value);

    setFormValues({ ...formValues, [name]: value });

    let parame=event.target.name;
    if (formErrors[parame]!=undefined&&formErrors[parame]!=null) delete formErrors[parame];
    setFormErrors(formErrors);

  }

   const handleCaptchaChange = (value) => {

        
    
        if(value!=null){ //alert(value);

            setRecaptchaValue(value);

            setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });

            if (formErrors["captchaValue"]!=undefined&&formErrors["captchaValue"]!=null) delete formErrors["captchaValue"];
            setFormErrors(formErrors);

         }
         else {
          //alert('reCaptcha is null');
          if (formValues["captchaValue"]!=undefined&&formValues["captchaValue"]!=null) delete formValues["captchaValue"];
          setFormValues(formValues);
         }
         

    }


  const handleSubmit = (e) => {

    e.preventDefault();

    //const captchaValue = ReCAPTCHA.current.getValue();

    if(formValues["phoneNumber"]!=undefined&&isValidPhoneNumber(formValues["phoneNumber"])===false){
      if (formValues["phoneNumber"]!=undefined&&formValues["phoneNumber"]!=null) delete formValues["phoneNumber"];
      setFormValues(formValues);
    }
    //else{
      //setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
    //}
    
    
    if (!recaptchaValue) {//alert("-----"+recaptchaValue)
      //alert('Please verify the reCAPTCHA!');
      //errors.captchaValue = "You must confirm that you're human, by clicking on the checkbox.";
      //setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
     // if (formValues["captchaValue"]!=undefined&&formValues["captchaValue"]!=null) delete formValues["captchaValue"];
     // setFormValues(formValues);
    }
    else{
      //alert("+++++"+recaptchaValue);
      setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
     }

     //setNationality({ value: 'BW', label: 'Botswana' });
     //setFormValues({ ...formValues, ["nationality"]: "{ value: 'BW', label: 'Botswana' }" });

    setFormValues({ ...formValues, ["nationality"]: nationality });
    
    setFormErrors(validate(formValues));

    setIsSubmit(true);

  };

    useEffect(() => {

       setNationality({ value: 'BW', label: 'Botswana' });
       setFormValues({ ...formValues, ["nationality"]: "{ value: 'BW', label: 'Botswana' }" });

       //alert("ok: "+nationality.value+". "+JSON.stringify(formValues['nationality']));

       if(login){
        history(`${process.env.PUBLIC_URL}/eservices/PaymentsEServices`);      
         }

    }, []);

    useEffect(() => {
      
      //setRecaptchaValue(value);
      setFormValues({ ...formValues, ["captchaValue"]: recaptchaValue });
      
     }, [recaptchaValue]);

  useEffect(() => {

    if (Object.keys(formErrors).length === 0 && isSubmit) {

      setRegisterBtnDisabled(true);

      const body_t=JSON.stringify({
        
        
        firstname:formValues['firstname'], 
        surname:formValues['surname'],
        password:formValues['password'],
        password_confirmation:formValues['passwordConfirm'], 
        phone_number:formValues['phoneNumber'],
        omang:formValues['omang'],
        nationality:nationality.value
        
        
      });

      trackPromise(
        registerRequest(drtsAPIURL+"register",body_t,'register')
      ); 
     // toast.success("Sending");

    }
    else{

      if (Object.keys(formErrors).length > 0 && isSubmit) {
        toast.error("Please fill all the required fields. There are errors in your form.");
       }

    }

}, [formErrors]);

  
const validate = (values) => {//alert('validate');

  const errors = {};
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
 

  if (!nationality) { //alert(JSON.stringify(nationality));
    errors.nationality = "You must select the country of your citizenship.";
  }

  if (!values.omang) {
    errors.omang = "You must enter the Omang Number/Passport Number";
  }

  if (!values.password) {
    errors.password = "You must enter the password";
  }

  if (!values.passwordConfirm) {
    errors.passwordConfirm = "You must re-enter the password";
  }

  if (values.passwordConfirm&&values.passwordConfirm!=values.password) {
    errors.passwordConfirm = "Password mismatch. Please re-enter the same password.";
  }

  if (!values.phoneNumber) {
    errors.phoneNumber = "You must enter a valid Botswana cellphone number.";
  }
  else {

    if(isValidPhoneNumber(values.phoneNumber)===false){

      //alert(" false: "+values.phoneNumber);
      errors.phoneNumber = "You must enter a valid Botswana mobile phone number.";

    }
    else{

      

      let cellphone=values.phoneNumber;
     
      if (cellphone.length > 0) {

        if(cellphone.substring(0,4)==="+267"){//+26776401949
         
             
             if(cellphone.length==12 && parseInt(cellphone[4]) == 7){
                setFormValues({ ...formValues, ["phoneNumber"]: "+267"+cellphone.substring(4) });
                //alert(" true: 1 "+"+267"+cellphone.substring(4));
               }
             else{
                errors.phoneNumber = "You must enter a valid Botswana mobile phone number.";
             }
         }
         else if(cellphone.substring(0,5)==="00267"){//0026771916078

           if(cellphone.length==13 && parseInt(cellphone[5]) == 7){
               setFormValues({ ...formValues, ["phoneNumber"]: "+267"+cellphone.substring(5) });
              // alert(" true: 2 "+"+267"+cellphone.substring(5));
            }
            else{
              errors.phoneNumber = "You must enter a valid Botswana mobile phone number.";
            }

         }
         else if(cellphone.length==8 && parseInt(cellphone[0]) == 7){

              setFormValues({ ...formValues, ["phoneNumber"]: "+267"+cellphone });
              //alert(" true: 3 "+"+267"+cellphone);

         }
         else{
          errors.phoneNumber = "You must enter a valid Botswana mobile phone number.";
         }
           
         }
         else{
          errors.phoneNumber = "You must enter a valid Botswana mobile phone number.";
         }
    }
    
  }

   
  if (!values.surname) {
    errors.surname = "You must enter the surname.";
  }
  
  
  if (!values.firstname) {
    errors.firstname = "You must enter the firstname.";
  }

  if (!values.captchaValue ||values.captchaValue==null) {//alert(recaptchaValue);
    errors.captchaValue = "You must confirm that you're human, by clicking on the checkbox.";
  }

      
  return errors;

};

  
 

  const [searchParams, setSearchParams] = useSearchParams(); 

  if(params.token!==undefined && params.token!==''){//alert(searchParams.get("token")+"itz not");
    
    if (!oneGovTokenExists) setOneGovTokenExists(true);
    
  }
  else{//alert(searchParams.get("token")+ " itz  ull");
    //setOneGovTokenExists(false);
  }

 
 
  async function registerRequest(url,body,eng) {//alert(url);
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((response) => {

          if (response.ok) { //alert(response.status+" -- "+response.ok);
        
            return response.json();
          }
          else{ //alert(response.status+" -not- "+response.ok);
            
            return response.json().then(text => { 
              //throw new Error(text) 
              if(text.message!=undefined){
              toast.error("Request failed: "+text.message);
              }
              else{
                toast.error("Request failed: Could not connect to the server");  
              }
            });
            
          }
        })
        .then((data) => {

          setRegisterBtnDisabled(false);
        
          if (data.status!=null&&data.status==true&&data.status!=undefined) {

            localStorage.setItem('user_id_temp', data.user.id);
            //navigate('/')
            //alert("user_id: "+data.user.id);
            setOmangExists(true);
            toast.success(data.message);

          } else {
            setOmangExists(false);
           
            if (data.status!=null&&data.status!=undefined) {
                 toast.error("Error: "+data.message);
              }
              else{
                toast.error("Ooops! An unexpected error occurred. Try again shortly.");
              }

          }
        })
    } catch (error) {
      setRegisterBtnDisabled(false);
      setOmangExists(false);
      console.log("Error: "+JSON.stringify(error));
      //toast.error("Oops...An error occurred! "+JSON.stringify(error));
    }
  }

  const handleCountryChange = (selectedCountry) => {

      const { label, value } = selectedCountry;//alert(value);
      setNationality(selectedCountry);     
      
    }

  function CountrySelector() {
      
      const options = useMemo(() => countryList().getData(), []);   
                      
    return <Select name="nationality" options={options} value={{ value: 'BW', label: 'Botswana' }} onChange={(selectedCountry) => handleCountryChange(selectedCountry)} />
  
  }

 
 

  return (
    <Fragment>
      <Container fluid={true} className="w-100 p-0 login-page">
        
       {omangExists ? (
        <OtpApp />
       ) :
        (<Row style={{"width":"100%"}} >
          <Col xs="12" style={{"width":"100%"}} >
            <div className="login-card" style={{"width":"60% !important"}}>

            { /* error && <div>{ error }</div> */ }
            { /*isPending && <div>Loading...</div> */}
            { /* diteng && <BlogList blogs={diteng} /> */ }

              <div className="register-main login-tab">

                <Form className="theme-form"  onSubmit={handleSubmit}>

                  <H3 style={{"color":"#6ec6ec"}}><div style={{"color":"#6ec6ec","paddingBottom":"5px"}}>{"DRTS PORTAL REGISTRATION"}</div></H3>
                 {/* <P>{"Enter your Credentials"}</P>*/}
                 <Row><Col>
                  <FormGroup>
                    <Label className="col-form-label">{"Firstname: "}</Label>
                    <Input name="firstname" className="form-control" type="text" onChange={handleChange} value={firstname} />
                    <span style={{ color: 'red' }}>{formErrors.firstname}</span>
                  </FormGroup>
                  </Col><Col>
                  <FormGroup>
                    <Label className="col-form-label">{"Surname: "}</Label>
                    <Input name="surname" className="form-control" type="text" onChange={handleChange} value={surname} />
                    <span style={{ color: 'red' }}>{formErrors.surname}</span>
                  </FormGroup>
                  </Col>
                </Row>

                <Row><Col>
                  <FormGroup>
                    <Label className="col-form-label">{"Omang/Passport Number: "}</Label>
                    <Input name="omang" className="form-control" type="text" onChange={handleChange} value={omang} />
                    <span style={{ color: 'red' }}>{formErrors.omang}</span>
                  </FormGroup>
                  </Col><Col>
                  <FormGroup>
                    <Label className="col-form-label">{"Nationality: "}</Label>
                    {/*<Input name="nationality" className="form-control" type="text" onChange={handleChange} value={nationality} />
                    
                    */}
                    <CountrySelector />
                    <span style={{ color: 'red' }}>{formErrors.nationality}</span>
                  </FormGroup>
                  </Col>
                </Row>

                <Row><Col>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">{"Password:"}</Label>
                    <div className="position-relative">
                      <Input name="password" className="form-control" type={togglePassword ? "text" : "password"} onChange={(e) => handleChange(e)} value={password} />
                      <div className="show-hide" onClick={() => setTogglePassword(!togglePassword)}>
                        <span className={togglePassword ? "" : "show"}></span>
                      </div>
                    </div>
                    <span style={{ color: 'red' }}>{formErrors.password}</span>
                  </FormGroup>
                  </Col><Col>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">{"Confirm Password:"}</Label>
                    <div className="position-relative">
                      <Input name="passwordConfirm" className="form-control" type={togglePasswordConfirm ? "text" : "password"} onChange={(e) => handleChange(e)} value={passwordConfirm} />
                      <div className="show-hide" onClick={() => setTogglePasswordConfirm(!togglePasswordConfirm)}>
                        <span className={togglePasswordConfirm ? "" : "show"}></span>
                      </div>
                    </div>
                    <span style={{ color: 'red' }}>{formErrors.passwordConfirm}</span>
                  </FormGroup>
                  </Col>
                </Row>

                <Row><Col>
                  <FormGroup>
                    <Label className="col-form-label">{"Cellphone Number: (Botswana Only) "}</Label>
                    <div className="position-relative">
                   
                    {/*<Input name="phoneNumber" className="form-control" type="text" onChange={handleChange} value={phoneNumber} />
                    */}
                  
                       <PhoneInput 
                           
                           className="form-control"
                           country="BW"
                           placeholder="Enter phone number"
                           defaultCountry="BW"
                           value={phoneNumber}
                           onChange={handlePhoneChange}  />
                           

                            {/*  <PhoneInput
                              value={phoneNumber} // Current value of the phone number input (required)
                              setValue={setPhoneNumber} // Function to set the value of the phone number input (required)
                              onChange={handlePhoneNumberChange} // Function called when the phone number changes (required)
                             />*/}


                    <div  >
                        <span className={""}></span>
                      </div>
                    </div>
                    <span style={{ color: 'red' }}>{formErrors.phoneNumber}</span>
                  </FormGroup>
                  </Col>
                </Row>

                <Row>
                 <Col> 

                <ReCAPTCHA onChange={(val)=>handleCaptchaChange(val)} sitekey={process.env.REACT_APP_SITE_KEY} />
                <span style={{ color: 'red' }}>{formErrors.captchaValue}</span>

                 </Col>
                </Row>

                <Row><Col>  
                  <div className="position-relative form-group mb-0">
                    
                                  <Btn disabled={registerBtnDisabled} attrBtn={{ disabled:registerBtnDisabled, color: "primary", className: "d-block w-100 mt-2" }}>{"Register"}</Btn>
                  </div>
                  </Col>
                </Row>
                
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      )}
      
      </Container>
      <ToastContainer />
    </Fragment>
  );
}

//export default Signin;
